<template>
        <div id="post" >
            <div class="row align-space-between">
                <router-link  style="color: black" :to="{ path: `/data/download/notice/${id}` }">
    
                    <div
                        class="row align-center"
                        style="gap: 12px"
                    >
                        <p style="font-size: 28px; font-weight: bold">{{ title }}</p>
                        <div
                            v-show="status != ''"
                            class="align-center status"
                        >
                            <p style="font-size: 12px">
                                공지
                            </p>
                        </div>
                    </div>
                </router-link>
                
            </div>
            <div class="row align-space-between" style="margin-top: 16px">
                <p style="font-size: 20px; font-weight: normal; color: #5f5f5f">
                    {{ category }}
                </p>
                <p style="font-size: 20px; font-weight: normal; color: #5f5f5f">
                    {{ downloadDate }}
                </p>
            </div>
        </div>
   
</template>

<script>
import { defineComponent, ref, onMounted } from "vue";
import TextButton from "./TextButton.vue";

export default defineComponent({
    props: {
        id: {
            type: Number,
            default: null
        },
        title: {
            type: String,
            default: "",
        },
        category: {
            type: String,
            default: "",
        },
        date: {
            type: String,
            default: "",
        },
      
        onClick: Function,
    },
    components: {
        TextButton
    },
    setup(props) {
        const downloadDate = ref("");

        const formatKoreanDate = (dateString) => {
            const date = new Date(dateString);
            return date
                .toLocaleDateString("ko-KR", {
                    year: "numeric",
                    month: "2-digit",
                    day: "2-digit",
                })
                .replace(/\. /g, "-")
                .slice(0, -1); // 한국 형식은 보통 "YYYY. MM. DD." 이므로 이를 변환합니다.
        };


        onMounted(() => {
            downloadDate.value = formatKoreanDate(props.date)
        })
        return { formatKoreanDate,  downloadDate,  };
    },
});
</script>

<style scoped>
button {
    padding: 8px;
    border: 0.5px solid #b0b0b0;
}

#post {
    width: 100%;
    padding: 16px 24px;
    border-bottom: 1px solid #b3b3b3;
    cursor: pointer;
    background: #f0f0f0
}

.status {
    height: 28px;
    border: 1px solid #c0c0c0;
    background:white;
    padding: 2px 16px;
    border-radius: 20px;
    color: blue;
}
</style>
